import { createSlice } from '@reduxjs/toolkit';

import { items } from 'config/menu';

export const menuSlice = createSlice({
    name: 'menu',
    initialState: {
        menuItems: items,
        activeItem: 'casino',
    },
    reducers: {
        setActiveItem(state, action) {
            state.activeItem = action.payload;
        },
    },
});

export const menuSelector = (state) => state.menu;
export const { setActiveItem } = menuSlice.actions;
export default menuSlice.reducer;